export default "__VITE_ASSET__d0ea35c2__"